import { queryParamHookFactory } from '../../../modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from '../../../modules/taboola-common-frontend-modules/storage';

export const CHAT_PROMPT_VERSION_PARAM_NAME = 'chat-prompt-version';

export const useChatPromptVersion = queryParamHookFactory(CHAT_PROMPT_VERSION_PARAM_NAME, {
    persist: PERSISTENCE_TYPE.MEMORY,
});
